import React from 'react';
import { Condition } from '../types/budget';
import { ClockIcon, SendIcon, CheckCircleIcon, FlagIcon } from 'lucide-react';
interface InlineConditionsProps {
  conditions: Condition[];
  onEditCondition: (c: Condition) => void;
}
export function InlineConditions({
  conditions,
  onEditCondition
}: InlineConditionsProps) {
  if (conditions.length === 0) return null;
  const getStatusIcon = (status: Condition['status']) => {
    switch (status) {
      case 'pending':
        return <ClockIcon className="w-4 h-4 text-accent-1" data-id="element-69" />;
      case 'sent':
        return <SendIcon className="w-4 h-4 text-accent" data-id="element-70" />;
      case 'resolved':
        return <CheckCircleIcon className="w-4 h-4 text-tertiary" data-id="element-71" />;
    }
  };
  const getStatusBadgeClass = (status: Condition['status']) => {
    switch (status) {
      case 'pending':
        return 'bg-accent-1/20 text-yellow-800 border-accent-1/30';
      case 'sent':
        return 'bg-accent/10 text-accent border-accent/20';
      case 'resolved':
        return 'bg-tertiary/10 text-tertiary border-tertiary/20';
    }
  };
  return <div className="mt-8 bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden" data-id="element-72">
      <div className="bg-gray-50 px-6 py-4 border-b border-gray-200 flex items-center gap-2" data-id="element-73">
        <FlagIcon className="w-5 h-5 text-accent-1" data-id="element-74" />
        <h3 className="text-base font-heading font-medium text-primary" data-id="element-75">
          Category Conditions
        </h3>
        <span className="bg-white border border-gray-200 text-gray-600 text-xs py-0.5 px-2 rounded-full font-body font-normal ml-2 shadow-sm" data-id="element-76">
          {conditions.length}
        </span>
      </div>

      <div className="p-6 grid gap-4" data-id="element-77">
        {conditions.map(condition => <div key={condition.id} onClick={() => onEditCondition(condition)} className="group border border-gray-100 rounded-lg p-5 hover:border-accent/30 hover:shadow-md transition-all cursor-pointer bg-white relative overflow-hidden flex flex-col gap-3" data-id="element-78">
            <div className={`absolute left-0 top-0 bottom-0 w-1 ${condition.priority === 'High' ? 'bg-red-400' : condition.priority === 'Medium' ? 'bg-accent-1' : 'bg-gray-300'}`} data-id="element-79" />

            <div className="flex justify-between items-start pl-2" data-id="element-80">
              <h4 className="text-base font-heading font-medium text-primary" data-id="element-81">
                {condition.lineItemName}
              </h4>
              <div className={`flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs border ${getStatusBadgeClass(condition.status)}`} data-id="element-82">
                {getStatusIcon(condition.status)}
                <span className="capitalize font-medium" data-id="element-83">
                  {condition.status}
                </span>
              </div>
            </div>

            <p className="text-sm font-body font-normal text-gray-600 pl-2 bg-gray-50 p-3 rounded-md border border-gray-100" data-id="element-84">
              {condition.note}
            </p>
          </div>)}
      </div>
    </div>;
}